<template>


  <ModalContainer queryParam="f012Normal" ref="modalContainer" size="lg">
    <b-overlay id="overlay-background" :show="showOverlay" rounded="sm">

      <ModalViewFile v-if="fileToView" :urlFile="fileToView" v-model="isModalFileVisible" />
      <div class="mb-1 row p-1" v-if="dataProceso">
        <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
        <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
      </div>

      <div class="mb-1 text-center">
        <h5 class="text-primary">INFORME 12 B -</h5>

      </div>

      <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-"
        active-tab-class="font-weight-bold text-dark">
        <b-tab title="Imagen/Informe" active>
          <b-row>

            <div class="col-12">
              <label>Subir imágenes:</label>
              <b-row class="my-1">
                <b-col>
                  <b-form-file v-model="imagesToUpload" accept=".pdf" @change="onFileChange"
                    placeholder="Selecciona un archivo PDF" browse-text="Examinar"></b-form-file>
                </b-col>
                <b-col size="md">
                  <b-button v-if="dataJson12b.imagenes" variant="outline-success" @click="onViewFile">Ver
                    Anterior</b-button>
                </b-col>
              </b-row>
             </div>
             <div class="col-12"> 
              <label>Buscar diagnósticos:</label>
              <b-row>
                <b-col cols="10">
                  <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                    :minChars="3" :placeholder="'Buscar diagnostico...'" class="form-control-sm" />
                </b-col>
                <b-col cols="2" class="text-right">
                  <b-button variant="primary" size="sm" @click="agregarDiagnostico">
                    Agregar
                  </b-button>
                </b-col>
                <b-col class="my-4">
                  <b-table class="my-4" v-if="dataJson12b.tableDiagnosticos && dataJson12b.tableDiagnosticos.length"
                    :items="dataJson12b.tableDiagnosticos" :fields="fieldsDiagnosticos" small>
                    <template #cell(acciones)="data">

                      <b-button class="text-center" variant="danger" size="sm" @click="removeDiagnostico(data.index)">
                        <font-awesome-icon icon="circle-xmark" style="color: white" />
                      </b-button>

                    </template>

                  </b-table>
                </b-col>
              </b-row>
             </div>
             <div class="col-12">
              <b-row class="p-2">

                <b-col cols="8" class="my-1">
                  <label>Quien realizo el procedimiento?:</label>
                  <div v-if="doctortext">
                    <b-input-group>
                      <b-form-input disabled v-model="doctortext"></b-form-input>

                      <template #append>
                        <b-button variant="danger" title="Cambiar medico" @click="doctortext = null">
                          <i class="fa-solid fa-trash" />
                        </b-button>
                      </template>
                    </b-input-group>


                  </div>

                  <SearchOpts v-else v-model="dataJson12b.doctor"
                    :searchService="doctoresService.searchDoctoresByTermSelect" :placeholder="'Buscar doctor...'"
                    class="form-control-sm" />
                </b-col>


                <b-col class="mt-1" cols="12">
                  <label>Hallazgos:</label>
                  <b-form-textarea v-model="dataJson12b.hallazgos" />
                </b-col>

                <b-col class="mt-1" cols="12">
                  <label>Conclusiones y Sugerencias:</label>
                  <b-form-textarea v-model="dataJson12b.concsug" />
                </b-col>
              </b-row>


            </div>



          </b-row>
        </b-tab>



      </b-tabs>
      <div class="text-right mt-2">
        <b-button size="lg" variant="primary" @click="guardarInformeColposcopia()">
          <i class="fa-solid fa-floppy-disk"></i> Guardar
        </b-button>
      </div>

    </b-overlay>
  </ModalContainer>

</template>

<script>



import { doctoresService, auxiliarService, fileService } from "@/shared/services";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { mapState } from "vuex";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService } from "../../services";
import ModalViewFile from "../../../../shared/components/ModalViewFile/ModalViewFile.vue";

export default {
  directives: {

  },


  components: {
    SearchOpts,
    ModalContainer,
    ModalViewFile
  },

  props: {
    dataProceso: {
      default: null,
      required: false
    }
  },

  data() {
    return {
      showOverlay: false,
      idRegistroForm: null,
      tokenProceso: null,
      tokenFormulario: null,
      doctortext: "",
      auxiliartext: "",
      imagesToUpload: null,
      dataJson12b: {
        doctor: null,
        auxiliar: null,
        descripcion: null,
        informe: null,
        conclusion: null,
        concsug: null,
        hallazgos: null,
        diagnosticos: null,
        tableDiagnosticos: [],
        tableImagenes: [],
        grafico: {
          blob: null,
          checksSelected: null
        },
        msps: null,
        imagenes: null
      },

      fieldsDiagnosticos: [
        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],
      searchDoctor: null,
      searchAuxiliar: null,
      searchDiagnostico: null,
      doctoresService,
      auxiliarService,
      diagnosticosService,

      indexImgAct: null,
      imagenBase64: "",
      selectedCheckboxes: [],
      letters: ["A", "B", "C", "D", "E", "F", "G", "H"],
      numbers: [1, 2, 3, 4, 5, 6],

      selected: [],
      imagencolcos: "",
      webcamEncendida: false,
      fecharealizacion: "",
      seRealizo: false,

      informe: "",
      conclusion: "",
      doctor: null,
      auxiliar: null,
      fechaEjecucion: "",
      realizado: null,
      hallazgos: null,
      conclusugeren: null,
      descripcionproc: null,

      tableData: [
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
      ],

      diagnosticosearch: "",
      esPrincipal: false,
      doctores: [], // Agrega tus opciones para doctores
      auxiliares: [], // Agrega tus opciones para auxiliares
      opsDiagnosticos: [], // Agrega tus opciones para diagnósticos
      isLoading: false,
      diagnosticos: [], // Aquí almacenarás los diagnósticos agregados
      fieldsti: ["diagnostico", "acciones"], // Define los campos para la tabla

      capturedImgs: [], //Capturar solo las url de las imagenes
      capturedImageUrl: "", // URL de la imagen capturada actualmente
      files: [], // Aquí almacenarás los archivos seleccionados
      fileuploaded: "",
      isDragging: false, // Variable para detectar si se está arrastrando un archivo

      diags: [],
      fileToView: null,
      isModalFileVisible: false

    };
  },

  computed: {
    ...mapState({
      stdocsMsps: state => state.docsMsps.files
    }),


  },

  created() {
    if (this.jsonInforColpos) {
      this.dataJson12b = this.jsonInforColpos

      this.doctortext = this.jsonInforColpos?.doctor?.text
      this.auxiliartext = this.jsonInforColpos?.auxiliar?.text
    }

  },



  methods: {

    onFileChange(event) {
      const file = event.target.files[0];

      if (file && file.type !== "application/pdf") {
        this.imagesToUpload = null;

        this.$swal.fire({
          icon: "error",
          title: "Archivo inválido",
          text: "Solo se permiten archivos PDF.",
        });
      }
    },


    onViewFile() {
      this.fileToView = this.dataJson12b.imagenes;
      this.isModalFileVisible = true;
    },





    agregarDiagnostico() {
      if (!this.searchDiagnostico || !this.searchDiagnostico.text) {
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, seleccione un diagnóstico antes de agregar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      let diagnosticosYaExistentes = false

      const nuevoDiagId = {
        diag: this.searchDiagnostico?.value,
      };

      const nuevoDiagnostico = {
        diagnostico: this.searchDiagnostico?.text,
      };

      const dataTable = this.dataJson12b.tableDiagnosticos;

      if (dataTable && dataTable.length > 5) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 6 diagnosticos",
        });
        return;
      }


      this.dataJson12b.tableDiagnosticos.push(nuevoDiagnostico);
      this.diags.push(nuevoDiagId);

      this.searchDiagnostico = null
    },



    deleteImage(index) {
      this.dataJson12b.tableImagenes.splice(index, 1);
    },

    removeDiagnostico(index) {
      this.dataJson12b.tableDiagnosticos.splice(index, 1);
    },


    async guardarInformeColposcopia() {

       const dataTable = this.dataJson12b.tableDiagnosticos;
      console.log("data table", dataTable)
      if (!dataTable || dataTable.length < 1) {
        this.$swal.fire({
          icon: "info",
          text: "Debe agregar un diagnostico al menos"})
        return;
      }
      if (this.imagesToUpload) {
        this.dataJson12b.imagenes = await fileService.upload('imagenes', this.imagesToUpload, 'img');
      }

      const dataJson = JSON.stringify(this.dataJson12b);

      const params = {
        nameForm: "12bNormal",
        dataJson: dataJson,
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm,
        tokenFormulario: this.tokenFormulario
      }

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "Ocurrio un error al guardar",
          icon: "error",
          confirmButtonColor: "#089599",
        });
        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });
      this.$emit("formulario-guardado");


    }

  },


  watch: {
    '$route': {
      deep: true,
      immediate: true,
      async handler(newValue) {
        this.showOverlay = true
        if (newValue && newValue.query)
          console.log("new value", newValue)
        this.tokenProceso = newValue.query?.forms || null
        this.tokenFormulario = newValue.query?.f012Normal || null
        if (this.tokenFormulario && this.tokenFormulario !== 'x') {

          console.log("entra aqui token formulario", this.tokenFormulario)
          const data = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);
          let data_json = JSON.parse(data.dataJson)
          if (data_json) {
            this.dataJson12b = data_json

            console.log("data json", this.dataJson12b)

          }
        } else {

          this.selected = []
          this.dataJson12b = {
            doctor: null,
            auxiliar: null,
            descripcion: null,
            informe: null,
            conclusion: null,
            concsug: null,
            hallazgos: null,
            diagnosticos: null,
            tableDiagnosticos: [],
            tableImagenes: [],
            grafico: {
              blob: null,
              checksSelected: null
            },
            msps: null,
            imagenes: null
          }
        }
        this.showOverlay = false



      }
    },

    jsonInforColpos: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue)
          this.dataJson12b = newValue
      }
    },


    stdocsMsps: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.dataJson12b.msps = newVal
      }
    },

    dataJson12b: {
      deep: true,
      immediate: true,
      handler(newVal) {
        console.log("data json 12 b no colpos", newVal)
        localStorage.setItem("jsonInforme12bNoColpo", JSON.stringify(newVal))
      }
    },




  }
};
</script>
